
import { api, dashboardApi } from "@/api/api";
import { ApiGetWorkingHourDto, ApiWorkingHourUserIdFilter } from "@/api/generated/Api";
import BaseLayout from "@/components/shared/BaseLayout.vue";
import BaseTableFiltered from "@/components/shared/table/BaseTableFiltered.vue";
import { DashboardRouteNames } from "@/shared/enums/RouteNames/dashboardRouteNames.enum";
import { SingleCourseRouteNames } from "@/shared/enums/RouteNames/singleCourseRouteNames.enum";
import { WorkingHourStatusEnum } from "@/shared/enums/WorkingHourStatus.enum";
import { NotificationItemType } from "@/shared/enums/notificationItemEnum";
import { getDashboardUserId } from "@/shared/helpers/dashboardHelpers";
import { formatLocalizedDate } from "@/shared/helpers/dateHelpers";
import { globalLoadingWrapper, onParamChange } from "@/shared/helpers/loadingHelpers";
import { openNotification } from "@/shared/helpers/store.helpers";
import { useRouter, useStore } from "@/shared/useHelpers";
import { StoreState } from "@/store/store.state.interface";
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  components: { BaseTableFiltered, BaseLayout },
  name: "PendingWorkingHoursPage",
  setup() {
    const router = useRouter();
    const store = useStore<StoreState>();
    const workingHoursPendingApproval = ref<ApiGetWorkingHourDto[]>();
    const search = ref("");
    const currentEmployeeId = ref<number>();

    const displayWorkingHourEntry = (workingHourEntry: ApiGetWorkingHourDto) => {
      router.push({
        name: SingleCourseRouteNames.CourseWorkingHourDetails,
        params: {
          id: workingHourEntry.courseId.toString(),
          hourEntryId: workingHourEntry.id.toString(),
          isExternalResource: "courseContractId" in workingHourEntry ? "true" : "false",
        },
      });
    };

    const approveWorkingHourEntry = async (workingHourEntryId: number) => {
      globalLoadingWrapper({ blocking: true }, async () => {
        await api.economy.approveWorkingHourAsync([workingHourEntryId]);
        openNotification(store, NotificationItemType.Success, "Arbeidstimer godkjent");
        await loadWorkingHours();
      });
    };

    const loadWorkingHours = async () => {
      globalLoadingWrapper({ blocking: true }, async () => {
        currentEmployeeId.value = await getDashboardUserId();
        workingHoursPendingApproval.value = (
          await dashboardApi.economy.getWorkingHoursAsync({
            WorkingHourUserIdFilter: ApiWorkingHourUserIdFilter.COURSE_SUPERVISOR_ONLY,
            Statuses: [WorkingHourStatusEnum.NotApproved],
            UserId: currentEmployeeId.value,
          })
        ).data;
      });
    };

    onParamChange(loadWorkingHours);

    return {
      search,
      headers,
      DashboardRouteNames,
      workingHoursPendingApproval,
      displayWorkingHourEntry,
      approveWorkingHourEntry,
      formatLocalizedDate,
    };
  },
});

const headers = [
  { text: "Kurs-ID", value: "courseId" },
  { text: "Handlinger", value: "actions" },
  { text: "Kursnavn", value: "courseName" },
  { text: "Navn på ressurs", value: "userFullName" },
  { text: "Type timer", value: "costTypeName" },
  { text: "Dato", value: "date" },
  { text: "Status", value: "statusText" },
];
